import Model from './model';





export default Model.extend( {

    endpoint: 'departments',

} );


// WEBPACK FOOTER //
// ./src/js/model/organization.js